export const UNIT = {
  IMPERIAL: 1,
  METRIC: 2
}
